import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SvbrgChatMessageStatus } from '@/generated/gql/graphql';
import { ChatLoadingIndicator } from '@/legacy/components/Chat/ChatMessage/indicators/ChatLoadingIndicator';
import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';

export type IntakeSupplierSourcingStepProps = ChatMessageProps;

export const IntakeSupplierSourcingStep = ({ status, role, createdBy }: IntakeSupplierSourcingStepProps): ReactNode => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeSupplierSourcingStep' });

  // when it is completed, we do not render anything because the supplier selection follows
  if (status !== SvbrgChatMessageStatus.PENDING) {
    return null;
  }

  // while it is pending we just show a loading indicator
  return (
    <ChatStep title={tIntake('IntakeChatStep.assistant')} role={role} createdBy={createdBy} message="">
      <ChatLoadingIndicator message={t('initiating')} />
    </ChatStep>
  );
};
